<template>
  <b-card :header="client.name">
    <table class="table table-striped">
      <tbody>
        <tr class='text-center'>
          <td colspan=2>
            <img :src='client.logo_url' width="200" height="200" alt="Client logo">
          </td>
        </tr>
        <tr>
          <td>ID</td>
          <td>{{ client.id }}</td>
        </tr>
        <tr>
          <td>Site url</td>
          <td>
            <a :href="client.site_url" target='_blank'>{{client.site_url}}</a>
          </td>
        </tr>
        <tr>
          <td>Adworks name</td>
          <td>
            <a :href="'http://adworks.gosokal.com/clients/' + client.adworks_slug" target='_blank'>{{client.adworks_client_name}}</a>
          </td>

        </tr>
        <tr>
          <td>Client groups</td>
          <td>{{ client.client_group_names }}</td>
        </tr>
        <tr>
          <td>Callrail ID</td>
          <td>{{ client.callrail_id }}</td>
        </tr>
        <tr>
          <td>Analytic ID</td>
          <td>{{ client.analytics_id }}</td>
        </tr>
        <tr>
          <td>Analytic account email</td>
          <td>{{ client.analytic_account_email }}</td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
export default {
  name: 'Client',

  data () {
    return {
      client: {}
    }
  },

  created () {
    this.loadClient()
  },

  methods: {

    loadClient () {
      var clientId = this.$route.params.id
      this.currentClient = this.$store.getters.currentClient
      this.$http.get('/clients/' + clientId + '?domain=' + this.currentClient.domain)
        .then(function(response){
          this.client = response.data
        }.bind(this))
    }
  }

}
</script>

<style scoped>
</style>
